import { Component, HostBinding, Input } from '@angular/core';
import { ScheduleSlot } from '../../../interfaces/schedule';

@Component({
  selector: 'app-schedule-range',
  templateUrl: './schedule-range.component.html',
  styleUrls: ['./schedule-range.component.scss']
})
export class ScheduleRangeComponent {
  @Input() onlineClassText!: any;
  @Input() cancelledClassText!: any;
  @Input() hibridClassText!: any;
  @Input() slots!: ScheduleSlot[];
  @Input() homeMode: boolean = false;
  @Input() range!: number[];
  @Input() notificationsHeaderText: string = "";
  @HostBinding('style.--range-position') @Input() startPosition: number = 0;
}
